import { OrderFilterOptions } from 'const/OrderFilterOptions';
import React, { useEffect, useState } from 'react';
import './OrderFilterCheckboxes.scss';

interface OrderFilterCheckboxesProps {
  defaultValue?: SelectedOrderFilter;
  options?: Array<OrderFilterOptions>;
  onFilterChange?: (activeCheckboxFilters: SelectedOrderFilter) => void;
  type?: 'inline' | 'column';
}
export type SelectedOrderFilter = { [value in OrderFilterOptions]?: boolean };

export const OrderFilterCheckboxes = ({
  type = 'inline',
  ...props
}: OrderFilterCheckboxesProps) => {
  const [filterCheckboxes, setFilterCheckboxes] = useState<
    Array<OrderFilterOptions>
  >(Object.values(OrderFilterOptions));

  const [checkedFilter, setCheckedFilter] = useState<SelectedOrderFilter>(
    props.defaultValue
  );

  useEffect(() => {
    let filterOptions = filterCheckboxes;

    if (props.options) {
      filterOptions = props.options;
      setFilterCheckboxes(props.options);
    }

    const checkboxes = filterOptions.reduce((acc, currentValue) => {
      acc[currentValue] = props.defaultValue?.[currentValue] || false;
      return acc;
    }, {});
    setCheckedFilter(checkboxes);
  }, [props.options, filterCheckboxes, props.defaultValue]);

  const onCheckboxChange = (checkboxFilter: OrderFilterOptions) => {
    const currentCheckboxes = { ...checkedFilter };
    currentCheckboxes[checkboxFilter] = !currentCheckboxes[checkboxFilter];

    if (checkboxFilter === OrderFilterOptions.WITH_PARTNER_SCAN) {
      currentCheckboxes[OrderFilterOptions.WITHOUT_PARTNER_SCAN] = false;
    } else if (checkboxFilter === OrderFilterOptions.WITHOUT_PARTNER_SCAN) {
      currentCheckboxes[OrderFilterOptions.WITH_PARTNER_SCAN] = false;
    } else if (checkboxFilter === OrderFilterOptions.WITH_HUB_SCAN) {
      currentCheckboxes[OrderFilterOptions.WITHOUT_HUB_SCAN] = false;
    } else if (checkboxFilter === OrderFilterOptions.WITHOUT_HUB_SCAN) {
      currentCheckboxes[OrderFilterOptions.WITH_HUB_SCAN] = false;
    }

    setCheckedFilter(currentCheckboxes);
    props.onFilterChange && props.onFilterChange(currentCheckboxes);
  };

  return (
    <div className={`filter-checkbox ${type}`}>
      {filterCheckboxes.map(checkboxFilter => (
        <label key={checkboxFilter}>
          <input
            type="checkbox"
            checked={checkedFilter?.[checkboxFilter]}
            onChange={() => onCheckboxChange(checkboxFilter)}
          />
          {checkboxFilter}
        </label>
      ))}
    </div>
  );
};
